import React, { useState, useEffect, useContext } from 'react';
import '../Styles/SignUp.scss';
import Logo from '../Images/ht_logo_final.png';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { validateEmail } from '../Util/ValidateEmail';
import useFetch from '../CustomHooks/useFetch';
import getSlug from 'speakingurl';
import { makeStyles } from '@material-ui/core/styles';
import desktopImage from '../Images/signup_desktop_image.jpg';
import MessageBoxWithAction from './MessageBoxWithAction';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { GlobalContext } from '../Contexts/GlobalContext';
import DefaultLanguageSelector from './MultiLanguage/DefaultLanguageSelector';
import TimeZoneSelector from './MultiLanguage/TimeZoneSelector';
import CountrySelector from './MultiLanguage/CountrySelector';
import useGoogleAnalytics from '../CustomHooks/useGoogleAnalytics';


export default function SignUp() {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [yourName, setYourName] = useState('');
    const [yourNameError, setYourNameError] = useState('');
    const [restaurantName, setRestaurantName] = useState('');
    const [restaurantNameError, setRestaurantNameError] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [passwordAgain, setPasswordAgain] = useState('');
    const [passwordAgainError, setPasswordAgainError] = useState('');
    const [alias, setAlias] = useState('');
    const classes = useStyles();
    const [response, fetchData] = useFetch();
    const [errorFromServerMessage, setErrorFromServerMessage] = useState('');
    const [errorMessages, setErrorMessages] = useState({ email: '', yourName: '', restaurantName: '', password: '', passwordAgain: '', alias: '', });
    const [aggreementChecked, setAggreementChecked] = useState(false);
    const [agreementError, setAgreementError] = useState('');
    const [submittedBefore, setSubmittedBefore] = useState(false);
    const globalContext = useContext(GlobalContext);
    const [language, setLanguage] = useState('en');
    const [country, setCountry] = useState('GB');
    const [timeZone, setTimeZone] = useState('Europe/London');
    const [guiLanguage, setGuiLanguage] = useState('en');
    const [phone, setPhone] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [currency, setCurrency] = useState('gbp');
    const setGAPath = useGoogleAnalytics();

    useEffect(
        () => {
            //setGAPath('/SignUp');
        }, []
    )


    useEffect(
        () => {
            if (window.location.href.indexOf('lang=tr') > 0) {
                setGuiLanguage('tr');
                setCountry('TR');
                setCurrency('tl');
            }
        }, []
    )


    const validate = () => {

        let validated = true;
        if (!aggreementChecked) {
            validated = false;
            

            if(guiLanguage == 'tr') {
                setAgreementError('Lütfen Abonelik Sözleşmesini onaylayın');
            }
            else {
                setAgreementError('Please check Subscription Agreement');
            }
            
        }
        else {
            setAgreementError('');
        }

        

        if (!validateEmail(email)) {
            
            if(guiLanguage == 'tr') {
                setEmailError('Lütfen geçerli bir e-posta adresi girin.');
            }
            else {
                setEmailError('Please enter a valid email.');
            }

            validated = false;
        }
        else {
            setEmailError('');
        }



        if (yourName == '') {
            if(guiLanguage == 'tr') {
                setYourNameError('Lütfen adınızı girin.');
            }
            else {
                setYourNameError('Please enter your name.');
            }
            
            validated = false;
        }
        else {
            setYourNameError('');
        }

        if (phone == '') {
            if(guiLanguage == 'tr') {
                setPhoneError('Lütfen telefon numaranızı girin.');
            }
            else {
                setPhoneError('Please enter your phone number.');
            }
            
            validated = false;
        }
        else {
            setPhoneError('');
        }


        if (restaurantName == '') {
            if (guiLanguage == 'tr') {
                setRestaurantNameError('Restoran adını girin');
            }
            else {
                setRestaurantNameError('Please enter restaurant name');
            }

            validated = false;
        }
        else {
            setRestaurantNameError('');
        }

        if (password == '') {
            if (guiLanguage == 'tr') {
                setPasswordError('Lütfen parola girin');
            }
            else {
                setPasswordError('Please enter password');
            }
            
            validated = false;
        }
        else {
            setPasswordError('');
        }

        if (passwordAgain == '') {
            if (guiLanguage == 'tr') {
                setPasswordAgainError('Lütfen seçtiğiniz parolayı tekrar girin');
            }
            else {
                setPasswordAgainError('Please enter password again');
            }
            validated = false;
        }
        else {
            setPasswordAgainError('');

            if (password != passwordAgain) {
                if (guiLanguage == 'tr') {
                    setPasswordAgainError('Lütfen seçtiğiniz parolayı tekrar girin');
                }
                else {
                    setPasswordAgainError('Re-enter your password confirmation so it matches your password.');
                }

                validated = false;
            }
            else {
                setPasswordAgainError('');
            }
        }

        return validated;

    }

    const submitForm = async (e) => {
        e.preventDefault();

        if (submittedBefore) {
            return;
        }
        else {
            setSubmittedBefore(true);
        }


        if (!validate()) {
            setSubmittedBefore(false);
            return;
        }

        globalContext.dispatchMethod({ type: 'SET_MESSAGE', 
        value: { 
             message: guiLanguage == 'tr' ? 'Hesabınız açılıyor...' : 'Signing you up...',
             showButton: false } });
        fetchData(
            {
                url: '/api/Registration/register',
                method: 'POST',
                postData: {
                    email: email,
                    companyName: restaurantName,
                    country: country,
                    city: "No city",
                    address: "No address",
                    name: yourName,
                    surname: "No surname",
                    password: password,
                    companyAlias: getSlug(restaurantName),
                    langCode: guiLanguage == 'tr' ? 'tr' : language,
                    timeZoneId: guiLanguage == 'tr' ? 'Europe/Istanbul' : timeZone,
                    phoneNumber: phone,
                    currency: currency,
                },
                returnRawResponse: true,
            }
        )

    }

    useEffect(
        () => {

            async function f() {
                if (!Array.isArray(response)) { //response un default hali []

                    let responseJson = await response.json();

                    //if (responseJson.success) {
                    if (response.ok) {
                        window.location = '/SignUp__Success?lang=' + guiLanguage;
                    }
                    else {
                        

                        if (responseJson.errCode == "100") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Bu restoran ismi kullanımda, başka bir restoran ismi girin.");
                            }
                            else{
                                setErrorFromServerMessage("This restaurant name is in use, please try another one.");
                            }
                            
                            return;
                        }
                        if (responseJson.errCode == "101") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Bu e-posta adresi kullanımda.");
                            }
                            else{
                                setErrorFromServerMessage("This email address is in use. Please use Forgot Password on login screen to recover your password or contact support.");
                            }

                            
                            return;
                        }
                        if (responseJson.errCode == "103") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Bu restoran ismi kullanımda, başka bir restoran ismi girin.");
                            }
                            else{
                                setErrorFromServerMessage("This restaurant name is in use, please try another one.");
                            }
                            return;
                        }
                        if (responseJson.errCode == "102") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Beklenmeyen bir hata oluştu.");
                            }
                            else{
                                setErrorFromServerMessage("Unexpexted error");
                            }
                            return;
                        }

                        if (responseJson.errCode == "200") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Firma adı boş bırakılamaz.");
                            }
                            else{
                                setErrorFromServerMessage("Please enter the company name");
                            }
                            return;
                        }

                        if (responseJson.errCode == "201") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Firma adı çok kısa(5 karakterden az) veya uzun.");
                            }
                            else{
                                setErrorFromServerMessage("Company name too short(less than 5 letters) or long");
                            }
                            return;
                        }
                        
                        if (responseJson.errCode == "204") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("İsim alanı boş bırakılamaz.");
                            }
                            else{
                                setErrorFromServerMessage("Please enter your name");
                            }
                            return;
                        }

                        if (responseJson.errCode == "205") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("İsim fazla uzun. En fazla 150 harf olabilir");
                            }
                            else{
                                setErrorFromServerMessage("Name is too long, should be less than 150 letters");
                            }
                            return;
                        }

                        if (responseJson.errCode == "207") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Lütfen e-posta girin");
                            }
                            else{
                                setErrorFromServerMessage("Please enter e-mail");
                            }
                            return;
                        }

                        if (responseJson.errCode == "208") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Lütfen geçerli bir e-posta adresi girin");
                            }
                            else{
                                setErrorFromServerMessage("Please enter a valid e-mail address");
                            }
                            return;
                        }

                        if (responseJson.errCode == "209") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("e-posta adresi 80 harften çok olamaz");
                            }
                            else{
                                setErrorFromServerMessage("e-mail address must be less than 80 letters");
                            }
                            return;
                        }

                        if (responseJson.errCode == "210") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Lütfen parola girin");
                            }
                            else{
                                setErrorFromServerMessage("Please enter a password");
                            }
                            return;
                        }

                        if (responseJson.errCode == "211") {
                            if (guiLanguage == 'tr') {
                                setErrorFromServerMessage("Telefon numarası 15 rakamdan daha fazla olamaz");
                            }
                            else{
                                setErrorFromServerMessage("Phone number must be less than 15 characters");
                            }
                            return;
                        }
                        
                        setErrorFromServerMessage(responseJson.failMessage);
                        

                    }
                }
            }
            f();
            setSubmittedBefore(false);
            globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
        }, [response]
    )

    useEffect(
        () => {
            setAlias('https://happytable.app/restaurant-name');
        }, []
    )

    return (
        <div className="sign-up">
            <div className="sign-up__geyik-wrapper">
                <img src={Logo} className="sign-up__logo"></img>
                <div className="sign-up__geyik-title" >

                    {
                        guiLanguage == 'tr' ?
                            <React.Fragment>
                                30 GÜN ÜCRETSİZ DENEYİN!
                        </React.Fragment>
                            :
                            <React.Fragment>
                                30 DAY FREE TRIAL
                        </React.Fragment>
                    }
                </div>
                <div className="sign-up__geyik-text" >

                    {
                        guiLanguage == 'tr' ?
                            <React.Fragment>
                                <div>
                                Üstelik "Mobil QR Kod Menü" oluşturmak her zaman Ücretsiz.
                                </div>
                                <div style={{ margin: '10px 0',}}> 
                                Masadan "QR Kod Menü ile sipariş alma", "Garson Çağırma", "9 Yabancı Dilde Menü" ve "Gel-al" özelliklerini 30 gün boyunca ücretsiz kullanın!
                                </div>
                        </React.Fragment>
                            :
                            <React.Fragment>
                                Try out Happy Table free for 30 days to get Self Ordering, Click to Collect and Click to Deliver for your restaurant.
                        </React.Fragment>
                    }

                </div>
                <div>
                    <img src="https://happy-table-web-site.s3-us-west-2.amazonaws.com/images/tablet_image.png" className="sign-up__geyik-image"></img>
                </div>
                <div className="sign-up__desktop-vik-vik" >
                    <div><i className="material-icons" style={{ color: 'green' }}> bubble_chart </i>Self Ordering</div>
                    <div><i className="material-icons" style={{ color: '#f84304ff' }}> bubble_chart </i>Click to Collect</div>
                    <div><i className="material-icons" style={{ color: '#009aff' }}> bubble_chart </i>Click to Deliver</div>
                </div>
            </div>
            <div className="sign-up__inner-wrapper">
                <div className="sign-up__form-title">
                    {
                        guiLanguage == 'tr' ?
                            <React.Fragment>
                                HappyTable'ın tüm özelliklerini ücretsiz kullanmaya başlayın!
                        </React.Fragment>
                            :
                            <React.Fragment>
                                Start your free trial now!
                        </React.Fragment>
                    }


                </div>
                <div className="sign-up__form-text">

                    {
                        guiLanguage == 'tr' ?
                            <React.Fragment>
                                Aşağıdaki formu eksiksiz doldurduktan sonra üyelik için gerekli adımlar e-posta adresinize gönderilecektir.
                        </React.Fragment>
                            :
                            <React.Fragment>
                                Complete the form below and you will receive your account info to your mail in minutes.
                        </React.Fragment>
                    }

                </div>
                <TextField className={classes.marginTop} style={{ marginTop: '25px', }} id="email" label={guiLanguage == 'tr' ? 'e-posta' : 'e-mail'} value={email} onChange={(e) => setEmail(e.target.value)} helperText={emailError} error={emailError == '' ? false : true} />
                <TextField id="yourName" label={guiLanguage == 'tr' ? 'İsminiz' : 'Your name'} value={yourName} onChange={(e) => setYourName(e.target.value)}  error={yourNameError == '' ? false : true} />
                <TextField id="restaurantName" label={guiLanguage == 'tr' ? 'Restoran adı' : 'Restaurant name'} value={restaurantName} onChange={(e) => { setRestaurantName(e.target.value); setAlias('https://happytable.app/' + getSlug(e.target.value)) }}  error={restaurantNameError == '' ? false : true} />
                <TextField id="phoneNumber" className={classes.phoneNumber} type="number" label={guiLanguage == 'tr' ? 'Telefon numarası' : 'Phone number'} value={phone} onChange={(e) =>  setPhone(e.target.value)} error={phoneError == '' ? false : true} />
                <TextField id="alias" label="URL of your happy table menu" style={{ display: 'none', }} value={alias} helperText={errorMessages.alias} error={errorMessages.alias == '' ? false : true} />
                <TextField id="password" type="password" label={guiLanguage == 'tr' ? 'Parola' : 'Password'} value={password} onChange={(e) => setPassword(e.target.value)} helperText={passwordError} error={passwordError == '' ? false : true} />
                <TextField id="passwordAgain" type="password" label={guiLanguage == 'tr' ? 'Parola tekrar' : 'Password again'} value={passwordAgain} onChange={(e) => setPasswordAgain(e.target.value)} helperText={passwordAgainError} error={passwordAgainError == '' ? false : true} />
                
                {
                    guiLanguage != 'tr' ?
                        <React.Fragment>
                            <CountrySelector country={country} setCountry={setCountry} ></CountrySelector>
                            <DefaultLanguageSelector language={language} setLanguage={setLanguage}></DefaultLanguageSelector>
                            <TimeZoneSelector timeZone={timeZone} setTimeZone={setTimeZone} ></TimeZoneSelector>
                        </React.Fragment>
                        : null
                }


                <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.8rem' }}>
                    <Checkbox
                        checked={aggreementChecked}
                        onChange={(e) => setAggreementChecked(e.target.checked)}
                        name="checkedB"
                        color="primary"
                    />
                    {
                        guiLanguage == 'tr' ?
                            <span>
                                Sözleşmeyi onaylıyorum
                        </span>
                            :
                            <span>
                                I agree to the
                        </span>
                    }

                    <a target="_blank" href="https://mini.happytable.app/terms-of-service.html" className="forgot-password-link">
                        {
                            guiLanguage == 'tr' ?
                                <React.Fragment>
                                    Hizmet Sözleşmesi
                            </React.Fragment>
                                :
                                <React.Fragment>
                                    Terms of Service
                        </React.Fragment>
                        }

                    </a>

                </div>
                <div style={{ color: 'red' }}>{agreementError}</div>

                <Button id="submitButton" variant="contained" color="primary" style={{ marginTop: '30px' }} onClick={submitForm}>
                    {guiLanguage == 'tr' ? 'Üye ol' : 'Sign up'}
                </Button>
            </div>
            {
                errorFromServerMessage != '' ?
                    <MessageBoxWithAction doNotShowCancelButton ok={() => setErrorFromServerMessage('')}>
                        {errorFromServerMessage}
                    </MessageBoxWithAction>
                    : null
            }
        </div>
    );
}

const useStyles = makeStyles({
    marginTop: {
        marginTop: '10px',
    },
    desktopImageDiv: {
        backgroundImage: `url(${desktopImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '50%',
        display: 'none',
    },
    phoneNumber:{
        //number alanindaki oklardan kurtulmak icin
        '& input::-webkit-outer-spin-button':{
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '& input::-webkit-inner-spin-button':{
            '-webkit-appearance': 'none',
            margin: 0,
        },
    }
})